import { getData } from '~/utils/service';

/** One subspecialty (area of interest) from `GET /areas-of-interest/{aoiSpecialtyId}`. */
export type AreaOfInterestApi = { aoiName: string; id: number };

/** The subspecialties under one AOI specialty, sorted by name by the API. */
export const loadAreasOfInterest = async (
  aoiSpecialtyId: number,
  signal?: AbortSignal
): Promise<AreaOfInterestApi[]> =>
  await getData<AreaOfInterestApi[]>('aoisOptions', {
    pathParams: { specialtiesId: String(aoiSpecialtyId) },
    signal,
  });
